import React, { useState, useEffect, useRef } from 'react';
import { object } from 'prop-types';
import CorePricingFares from '../core-pricing-fares/core-pricing-fares.jsx';
import ToolBar from '../../ui-components/core-pricing-component/tool-bar/tool-bar.jsx';
import Modal from '@sabre/spark-react-core/modal';
import StoredCriteria from '../../ui-components/core-pricing-component/stored-criteria/stored-criteria.jsx';
import { ToastContainer, toast } from 'react-toast';
import {
    URL_SAVE_CRITERIA,
    URL_SAVE_CRITERIA_FILTER_OF_USER_ID,
    URL_CORE_PRICING_SAVE_CRITERIA_FILTER_OF_CONTEXT_ID
} from '../../end-points.js';
import useApi from '../../api-wrapper/use-api.js';
import {
    TOOL_BAR_BUTTONS
} from '../../utils/constants.js';
import { set } from 'lodash';
const CorePricing = ({ App }) => {
    const [corePricingConfigData, setCorePricingConfigData] = useState({
        primaryTableLength: [],
        joinTableData: [],
        totalItem: 0,
        loadTime: '',
        isCompleteAllData: false
    });
    const [corePricingConfig, setCorePricingConfig] = useState({
        isShowStoredCriteriaPopupModal: false,
        sepratorCaption: 0,
        storedCriteriaData: [],
        isOpenStoredCriteria: false,
        selectedTab: TOOL_BAR_BUTTONS[0].KEY,
        titleDetails: [],
        isSaveSearchCriteria: false
    });
    const [saveSearchCriteria, setSaveSearchCriteria] = useApi({});

    const [searchCriteriaConfig, setSearchCriteriaConfig] = useState({});
    const [savedSearchCriteriaTitle, setSavedSearchCriteriaTitle] = useState('');
    const [isShowNotification, setIsShowNotification] = useState(false);

    const getSearchCriteria = (searchCriteria, type, title) => {
        setSearchCriteriaConfig(searchCriteria);
        if (title)
            setSavedSearchCriteriaTitle(title);
    };
    const URL_SAVED_CRITERIA_SEARCH_USER_ID = `${URL_SAVE_CRITERIA}${URL_CORE_PRICING_SAVE_CRITERIA_FILTER_OF_CONTEXT_ID}-'${URL_SAVE_CRITERIA_FILTER_OF_USER_ID}'${App.User.userId}'`;

    useEffect(() => {
        if (!saveSearchCriteria.isLoading) {
            setCorePricingConfig({
                ...corePricingConfig,
                isSaveSearchCriteria: false
            });
            if (!saveSearchCriteria.error && !Array.isArray(saveSearchCriteria.data)) {
                toast.success('Query Name Saved Successfully.', { backgroundColor: '#268440' });
            }
            else if (saveSearchCriteria.error && Array.isArray(saveSearchCriteria.data)) {
                toast.warn(saveSearchCriteria.message);
            }
        }
    }, [saveSearchCriteria.isLoading]);

    const getClonedCopyCollections = (list) => {
        return list.map(item => { return { ...item } })
    };

    const handleQueryNameSave = (toolBarConfig) => {
        if (!toolBarConfig.queryName && !isShowNotification) {
            setTimeout(() => {
                setIsShowNotification(false);
            }, 3000);
            setIsShowNotification(true);
            return toast.warn('Query Name is empty.');
        }
        const getSearchDetails = [...searchCriteriaConfig]
        const filterRecords = getSearchDetails.filter(list => (list.categeryName !== 'Table' && list.categeryName !== 'Products' && list.categeryName !== 'Market'));
        let defaultParsingData = [...filterRecords];
        let removedEmptyItems = [];
        const removedList = getClonedCopyCollections(defaultParsingData).filter(list => {
            const subListResult = list.categoryDetails.filter(sublist => {
                if (sublist.values.length > 0)
                    return sublist;
            });
            const filledItems = subListResult.filter((item) => {
                return item.values.filter(subItem => {
                    if (subItem) {
                        removedEmptyItems.push(subItem)
                        return subItem;
                    }
                });
            });
            if (filledItems.length > 0) {
                list.categoryDetails = subListResult;
                return list;
            }
        });
        const finalObject = {};
        finalObject.contextId = 'core-pricing';
        finalObject.title = toolBarConfig.queryName;
        finalObject.userId = App.User.userId;
        finalObject.isFavourite = false;
        finalObject.description = '';
        finalObject.value = {};
        finalObject.value.rules = [];
        removedList.map((list) => {
            list.categoryDetails.map((subItem) => {
                const newParsingData = {};
                newParsingData.category = list.categeryName;
                newParsingData.criterion = subItem.key;
                newParsingData.leftOperand = subItem.values;
                newParsingData.operator = subItem.operator;
                newParsingData.rightOperand = [];
                finalObject.value.rules.push(newParsingData);
            });
        });

        if (removedEmptyItems.length > 0) {
            setSaveSearchCriteria({ method: 'POST', url: URL_SAVED_CRITERIA_SEARCH_USER_ID, data: finalObject });
            setCorePricingConfig({
                ...corePricingConfig,
                isSaveSearchCriteria: true
            });
        } else {
            if (!isShowNotification) {
                setTimeout(() => {
                    setIsShowNotification(false);
                }, 3000);
                toast.warn('Search Criteria fields is empty.');
                setIsShowNotification(true);
            }
        }
    };
    const parsingStoredCriteriaData = (storedCriteriaData) => {
        if (storedCriteriaData) {
            return storedCriteriaData.data.map((list) => {
                list.isRowEdit = false;
                list.isQueryNameEdit = false;
                list.isDescriptionEdit = false;
                return list;
            }
            );
        } else
            return [];
    };
    const handleOpenStoredCriteriaModal = () => {
        const storedCriteriaList = parsingStoredCriteriaData(JSON.parse(window.localStorage.getItem('queryNames')));
        setCorePricingConfig({ ...corePricingConfig, storedCriteriaData: storedCriteriaList, isShowStoredCriteriaPopupModal: true, isOpenStoredCriteria: true });
    };
    const handleStoredCriteriaModalCloseOnClick = () => {
        setCorePricingConfig({ ...corePricingConfig, isOpenStoredCriteria: false });
    };
    const reSetStoredCriteriaPopupFlag = () => {
        setCorePricingConfig({ ...corePricingConfig, isOpenStoredCriteria: true });
    };
    const handleClosePopup = () => {
        setCorePricingConfig({ ...corePricingConfig, isShowStoredCriteriaPopupModal: false, isOpenStoredCriteria: false });
    };

    const handleSelectStoredCriteria = (selectedItem) => {
        const selectedDetails = selectedItem[0].value.rules;
        let isValue = false;
        const updatedResult = searchCriteriaConfig.map((list) => {
            const result = selectedDetails.filter((item) => list.categeryName === item.category);
            list.categoryDetails.map((subList) => {
                const findKeyItems = result.find(subItems => subItems.criterion === subList.key);
                if (findKeyItems) {
                    subList.operator = findKeyItems.operator;
                    subList.values = findKeyItems.leftOperand;
                    if (subList.key === 'tariffnumber' && subList.key === findKeyItems.criterion) {
                        isValue = true;
                    }
                } else {
                    subList.operator = '=';
                    subList.values = '';
                }
                return subList;
            })
            return list;
        });
        getSearchCriteria(updatedResult, 'default', selectedItem[0].title);
        setCorePricingConfig({ ...corePricingConfig, isShowStoredCriteriaPopupModal: false, isOpenStoredCriteria: false });
    };

    const handleSetSelectedTabChange = (selectedTab) => {
        setCorePricingConfig({
            ...corePricingConfig,
            selectedTab
        });
    };

    const handleNotification = () => {
        toast.warn('Pagination in-progress. Please wait untill pagination is completed.');
    };
    const handlegetLoadTime = (loadTime) => {
        setCorePricingConfigData({
            ...corePricingConfigData,
            loadTime: loadTime
        });
    }





    const getTableData = (tableDetails) => {
        setCorePricingConfigData({
            ...corePricingConfigData,
            primaryTableLength: tableDetails.primaryTableLength,
            joinTableData: tableDetails.isCompleted ? tableDetails.joinTable : [],
            totalItem: tableDetails.totalItem,
            isCompleteAllData: tableDetails.isCompleted
        })
    };

    const getFullDataIsAvailable = (isAllData) => {
        setCorePricingConfigData({
            ...corePricingConfigData,
            isCompleteAllData: isAllData
        });
    }
    return (
        <div className='core-pricing-root-view'>
            <div className=' row dashboard-top-toolbar spark-pad-t-.5 spark-pad-b-.5 spark-pad-l-.5 spark-pad-r-.5'>
                <ToolBar
                    title={savedSearchCriteriaTitle}
                    isDisable={corePricingConfigData.primaryTableLength > 0 ? false : true}
                    isCompleteAllData={corePricingConfigData.isCompleteAllData}
                    data={corePricingConfigData.joinTableData}
                    handleQueryNameSave={handleQueryNameSave}
                    handleOpenStoredCriteriaModal={handleOpenStoredCriteriaModal}
                    handleSetSelectedTabChange={handleSetSelectedTabChange}
                    totalItems={corePricingConfigData.totalItem ? corePricingConfigData.totalItem.toString() : '0'}
                    handleNotification={handleNotification}
                    handlegetLoadTime={handlegetLoadTime}
                />{
                    !corePricingConfig.isShowStoredCriteriaPopupModal &&
                    <ToastContainer position='top-right' delay={3000} />
                }
            </div>
            {corePricingConfig.isShowStoredCriteriaPopupModal && <Modal
                onClose={handleStoredCriteriaModalCloseOnClick}
                open={corePricingConfig.isShowStoredCriteriaPopupModal}
                titleHeadingLevel={3}
                modalId='dashboard-search-modal'
                className={`dashboard-search-modal${corePricingConfig.isShowStoredCriteriaPopupModal ? '' : ' spark-hidden'} `}
                contentClassName='col-xs-12 col-sm-12 col-md-11 col-lg-8 col-xl-6'>
                <StoredCriteria
                    isOpen={corePricingConfig.isOpenStoredCriteria}
                    data={corePricingConfig.storedCriteriaData}
                    currentUser={App.User.userId}
                    handleClosePopup={handleClosePopup}
                    handleSelectStoredCriteria={handleSelectStoredCriteria}
                    reSetStoredCriteriaPopupFlag={reSetStoredCriteriaPopupFlag}
                />
            </Modal>
            }
            <CorePricingFares
                app={App}
                getTableData={getTableData}
                getSearchCriteriaParent={getSearchCriteria}
                loadTime={corePricingConfigData.loadTime}
                getFullDataIsAvailable={getFullDataIsAvailable} />
        </div>
    )
};

CorePricing.propTypes = {
    App: object
};

export default CorePricing;